import { ResponseSuccess } from '@forwardflow/types'
import { apiGet } from '../Axios/configs'

export interface Lead {
   id: string
   meta: {
      appointment: {
         date: string
         status: string
         platform: string
      }
   }
   leadId: number
   email: string
   phoneNo: string
   lastName: string
   firstName: string
   stageInfo: {
      id: string
      name: string
      stageGroup: {
         id: string
         name: string
         type: string
      }
   }
   lastConversation: {
      date: string
      type: string
      content: string
   }
   unreadMessages: number
}

export interface Tag {
   id: string
   name: string
}

export interface UserInfo {
   id: number
   email: string
   phone: string
   avatar: string
   lastName: string
   firstName: string
}

export interface AgentInfo {
   id: string
   avatar: string
   lastName: string
   firstName: string
   phone?: string
   demoRealtorPhone?: string
}

export interface StageInfo {
   id: string
   name: string
   enteredAt: string
}

export interface SourceInfo {
   id: string
   name: string
   addedAt: string
}

export interface ContextualInfo {
   leadSummary: string
}

export interface AppointmentInfo {
   id: string
   date: string
   type: string
   status: string
   location: string
   platform: string
}
export interface AssistantInfo {
   avatar: string
   name: string
}

export interface ConversationInfo {
   messagesSent: number
   callsAnswered: number
   callsAttempted: number
   messagesReplied: number
}

export interface LeadDetailData {
   tags: Tag[]
   leadType: string
   userInfo: UserInfo
   assistant: AssistantInfo
   agentInfo: AgentInfo
   stageInfo: StageInfo
   sourceInfo: SourceInfo
   contextualInfo: ContextualInfo
   appointmentInfo: AppointmentInfo
   conversationInfo: ConversationInfo
   timelineSummary?: string
   questions?: string
   leadInterestType?: string
   leadSummary?: string
   preDefinedTimelineHistory?: any[]
}

export interface LeadData {
   success: boolean
   statusCode: number
   message: string
   data: {
      timestamp: Date
      leads: Lead[]
   }
}

export class LeadService {
   static async getLeadById(leadId: number) {
      const response = await apiGet<ResponseSuccess<LeadDetailData>>({
         apiPath: `/lead-details/${leadId}?includeLinks=true`,
      })
      return response.data
   }
}
